import type { CurrentFieldValues, DataRequestFieldResponse } from "../../models/data-request.model";

type IndicatorValue = NonNullable<CurrentFieldValues["values"]>[number];

export interface ValueRow {
  clientKey: string;
  id?: string;
  dataLineId: string;
  date: string;
  value: string;
  comment: string;
}

export interface EmittedRow {
  id?: string;
  dataLineId?: string;
  date: string;
  value: number;
  comment: string | null;
}

export function extractSavedRows(newValue: unknown): unknown[] | null {
  if (newValue && typeof newValue === "object" && "rows" in newValue && Array.isArray((newValue as { rows: unknown }).rows)) {
    return (newValue as { rows: unknown[] }).rows;
  }
  return null;
}

export function buildInitialRows(
  savedResponse: DataRequestFieldResponse | null,
  currentValues: IndicatorValue[],
  defaultDataLineId: string,
): ValueRow[] {
  const savedRows = savedResponse ? extractSavedRows(savedResponse.newValue) : null;
  const source = savedRows ?? currentValues;
  return source.map((entry, index): ValueRow => {
    const row = (entry ?? {}) as Partial<IndicatorValue>;
    return {
      clientKey: row.id ?? `saved-${index}`,
      id: row.id,
      dataLineId: row.dataLineId ?? defaultDataLineId,
      date: row.date ? String(row.date) : "",
      value: row.value === null || row.value === undefined ? "" : String(row.value),
      comment: row.comment ?? "",
    };
  });
}

export function toEmittedRows(rows: ValueRow[]): EmittedRow[] {
  return rows
    .map((row) => ({ row, numericValue: Number(row.value) }))
    .filter(
      ({ row, numericValue }) =>
        row.value.trim() !== "" && row.date.trim() !== "" && Number.isFinite(numericValue),
    )
    .map(({ row, numericValue }) => ({
      ...(row.id ? { id: row.id } : {}),
      dataLineId: row.dataLineId || undefined,
      date: row.date,
      value: numericValue,
      comment: row.comment.trim() === "" ? null : row.comment,
    }));
}
